import * as Yup from 'yup';

export const MarketPlaceAddCategorySchema = Yup.object().shape({
	title: Yup.string().required('Veuillez renseigner un nom pour la catégorie'),
	description: Yup.string().required('Veuillez renseigner une description pour la catégorie').min(1).max(50, 'La description ne doit pas dépasser 50 caractères')
})